import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
const Index = lazy(() => import('../pages/index/index'))
const Business = lazy(() => import('../pages/Business'))
const ContactUs = lazy(()=> import('../pages/ContactUs'))
const AboutUs = lazy(()=> import('../pages/AboutUs'))



const route = [
    {
        path: '/',
        key: 'Index',
        element: <Index/>,
    },
    {
        path: '/business',
        key: 'business',
        element: <Business/>,
    },
    {
        path: '/contact',
        key: 'contact',
        element: <ContactUs/>,
    },

    {
        path: '/about',
        key: 'AboutUs',
        element: <AboutUs/>,
    },
]
export default route;
